
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const categories = [
  {
    name: "Xis",
    description: "Hambúrgueres artesanais com ingredientes frescos e saborosos",
    image: "https://i.postimg.cc/hv7Chrcp/IMG-20250522-221835385-PORTRAIT-2.jpg",
  },
  {
    name: "Ala Minutas",
    description: "Pratos completos com arroz, feijão, salada e acompanhamentos",
    image: "/lovable-uploads/9b68fa7a-09c7-457c-bbe8-d6c68da3dff5.png",
  },
  {
    name: "Porções",
    description: "Porções generosas ideais para compartilhar com os amigos",
    image: "https://i.postimg.cc/Vv8tKsV4/IMG-20250515-202626490.jpg",
  },
  {
    name: "Dogs",
    description: "Cachorros-quentes com recheios especiais e muito sabor",
    image: "https://i.postimg.cc/vmYsKpT3/IMG-20250531-205545910-PORTRAIT-2.jpg",
  },
];

export function MenuHighlights() {
  const navigate = useNavigate();
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="cardapio" className="py-16 sm:py-24 bg-background text-foreground transition-colors duration-300">
      <div ref={ref} className="container mx-auto px-4 sm:px-6">
        <div
          className={`text-center mb-16 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-950 dark:text-white">
            Nossos <span className="text-krecao-red">Destaques</span>
          </h2>
          <div className="w-20 h-1 bg-amber-500 dark:bg-krecao-yellow mx-auto"></div>
          <p className="mt-6 text-gray-700 dark:text-gray-300 font-medium max-w-xl mx-auto">
            Conheça nossas categorias e escolha o que mais combina com você!
          </p>
        </div>

        <div className="flex overflow-x-auto pb-8 -mx-4 px-4 sm:mx-0 sm:px-0 sm:grid sm:grid-cols-2 lg:grid-cols-4 gap-6 snap-x snap-mandatory hide-scrollbar">
          {categories.map((cat, index) => (
            <Card
              key={cat.name}
              onClick={() => navigate("/menu")}
              className={`min-w-[75vw] sm:min-w-0 snap-center shrink-0 bg-card text-card-foreground border border-border shadow-sm rounded-2xl overflow-hidden hover:border-krecao-yellow hover:shadow-[0_0_15px_rgba(253,212,15,0.2)] transition-all duration-500 group cursor-pointer ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: isVisible ? `${index * 150}ms` : "0ms" }}
            >
              <div className="relative h-52 sm:h-72 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
                <h3 className="absolute bottom-4 left-4 text-2xl font-bold text-white group-hover:text-krecao-yellow transition-colors">
                  {cat.name}
                </h3>
              </div>
            </Card>
          ))}
        </div>

        <div className="text-center mt-10">
          <Button
            onClick={() => navigate("/menu")}
            size="lg"
            className="bg-krecao-red hover:bg-krecao-red/90 text-white rounded-full px-6 sm:px-10 py-4 sm:py-7 text-base sm:text-xl font-bold shadow-lg hover:shadow-krecao-red/40 transition-all duration-300 transform hover:scale-105 gap-2"
          >
            Cardápio Promocional
            <ArrowRight className="h-5 w-5 sm:h-6 sm:w-6" />
          </Button>
        </div>
      </div>
    </section>
  );
}
